import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Edition-t",
  "use": "icon-Edition-t-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Edition-t\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 460.8a51.2 51.2 0 0 0-51.2 51.2v153.6a51.2 51.2 0 0 0 102.4 0v-153.6a51.2 51.2 0 0 0-51.2-51.2z m0-358.4a409.6 409.6 0 1 0 409.6 409.6 409.6 409.6 0 0 0-409.6-409.6z m0 716.8a307.2 307.2 0 1 1 307.2-307.2 307.2 307.2 0 0 1-307.2 307.2z m25.6-512h-51.2a25.6 25.6 0 0 0-25.6 25.6v51.2a25.6 25.6 0 0 0 25.6 25.6h51.2a25.6 25.6 0 0 0 25.6-25.6v-51.2a25.6 25.6 0 0 0-25.6-25.6z\" fill=\"\" p-id=\"7518\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Edition-t.svg
// module id = 3vA4
// module chunks = 50